import React from 'react';

import { PrsDeductionCapTypeEnum } from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';

import { ContractTermInfoButton } from 'src/components/ContractTermInfoButton';
import { Input } from 'src/components/Input';
import { prsDeductionCapInputValidationRules } from 'src/components/RateCardDetail/ContractTerms/contractTermValidation';
import { ContractTermName } from 'src/constants/contractTermHelpInfo';
import { IContractTermsComponentProps } from 'src/types/IRateCard';

export const PrsDeductionCap: React.FC<IContractTermsComponentProps> = ({
    contractTerms,
    isEditMode,
    handleContractTermValueChange,
    contractTermErrorMessages,
    handleContractTermErrorMessageChange
}: IContractTermsComponentProps) => {
    const handlePrsDeductionErrorMessage = (newVal: string) => {
        if (!handleContractTermErrorMessageChange) return;
        handleContractTermErrorMessageChange('prsDeductionCap', 'value', newVal);
    };

    return (
        <Box className="box-border-light-gray" type="outline" spacingInset="400">
            <Column>
                <Row spacing="none">
                    <Heading level={3}>Cap PRS deductions</Heading>
                    <ContractTermInfoButton contractTermName={ContractTermName.CapPRSdeductions} />
                </Row>
                <Text type="b200" color="secondary">
                    By default allowable deductions will be 100% of royalties.
                </Text>
                <Row widths="50%" alignmentVertical="top">
                    <Column spacing="100">
                        {isEditMode ? (
                            <Select
                                label={'Select deduction cap model'}
                                value={contractTerms.prsDeductionCap?.type || PrsDeductionCapTypeEnum.ROYALTY}
                                onChange={(newVal) =>
                                    handleContractTermValueChange(
                                        'prsDeductionCap',
                                        'type',
                                        newVal.toString().toUpperCase()
                                    )
                                }
                                size="xlarge"
                            >
                                {Object.keys(PrsDeductionCapTypeEnum).map((deductionType) => (
                                    <SelectOption
                                        key={deductionType}
                                        value={deductionType}
                                        label={'Percentage of ' + deductionType.toLowerCase()}
                                    />
                                ))}
                            </Select>
                        ) : (
                            <Input
                                label="Deduction cap model"
                                value={
                                    'Percentage of ' +
                                    (
                                        contractTerms.prsDeductionCap?.type || PrsDeductionCapTypeEnum.ROYALTY
                                    ).toLowerCase()
                                }
                                isEditMode={false}
                            />
                        )}
                    </Column>
                    <Column spacing="100">
                        {isEditMode ? (
                            <Input
                                label="Deduction cap percentage"
                                value={(contractTerms.prsDeductionCap?.value ?? 1).toString()}
                                isEditMode={isEditMode}
                                isRequired={true}
                                type="number"
                                onChange={(newVal) => handleContractTermValueChange('prsDeductionCap', 'value', newVal)}
                                validationRules={prsDeductionCapInputValidationRules}
                                errorMessage={contractTermErrorMessages!.prsDeductionCap.value}
                                handleErrMsgChange={handlePrsDeductionErrorMessage}
                            />
                        ) : (
                            <Input
                                label="Deduction cap percentage"
                                value={`${parseFloat(
                                    (parseFloat((contractTerms.prsDeductionCap?.value || 1).toString()) * 100).toFixed(
                                        2
                                    )
                                )}%`}
                                isEditMode={false}
                            />
                        )}
                    </Column>
                </Row>
            </Column>
        </Box>
    );
};
